import React from 'react'
import PropTypes from 'prop-types'
import Icon from '../../../../../atoms/Icon'
import { ICON_NAMES } from '../../../../../../constants'
import { pluralize } from '../../../../../../utils'

function TaskCountBadge ({ count }) {
  if (!count) return null
  return (
    <span
      className='flex items-center font-size-sm font-medium'
      style={{ gap: '4px', color: 'var(--color-primary-500)', whiteSpace: 'nowrap', flexShrink: 0 }}
    >
      <Icon name={ICON_NAMES.list} customSize={14} color='var(--color-primary-500)' />
      <span>{count} {pluralize(count, 'task')}</span>
    </span>
  )
}

TaskCountBadge.propTypes = {
  count: PropTypes.number
}

export default TaskCountBadge
